import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "w-full flex" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Verstuur")
const _hoisted_3 = { key: "success" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_TransitionGroup, { name: "fade" }, {
    default: _withCtx(() => [
      (!$setup.success)
        ? (_openBlock(), _createElementBlock("form", {
            key: "form",
            onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onSubmit && $setup.onSubmit(...args))),
            class: "grid"
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent($setup.apiErrors.render()), {
              data: $setup.apiErrors.get()
            }, null, 8 /* PROPS */, ["data"])),
            _createVNode($setup["FormInput"], {
              name: "first_name",
              type: "text",
              label: "Naam",
              placeholder: "Naam",
              class: "mb-[16px]"
            }),
            _createVNode($setup["FormInput"], {
              name: "email",
              type: "email",
              label: "E-mailadres",
              placeholder: "E-mailadres",
              class: "mb-[16px]"
            }),
            _createVNode($setup["FormInput"], {
              name: "company",
              type: "text",
              label: "Bedrijf",
              placeholder: "Bedrijf",
              class: "mb-[16px]"
            }),
            _createVNode($setup["FormInput"], {
              name: "comment",
              type: "textarea",
              label: "Bericht",
              placeholder: "Bericht",
              class: "mb-[16px]"
            }),
            _createVNode($setup["FormCheckbox"], {
              value: false,
              class: "mb-[24px] text-14",
              name: "terms",
              label: "Ik ga er mee akkoord dat Baanbreker mijn informatie verwerkt zoals omschreven in ons <a class='text-purple-500 hover:no-underline underline' href='/privacy-clausule'>Privacy Beleid</a>."
            }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode($setup["Submit"], {
                disabled: $setup.success,
                loading: $setup.isSubmitting || $setup.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "loading"])
            ])
          ], 32 /* HYDRATE_EVENTS */))
        : _createCommentVNode("v-if", true),
      ($setup.success)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Bedankt voor je bericht. Het is verzonden."))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}